// Angular Files
import { Pipe, PipeTransform } from '@angular/core';

// CLDR Windows-to-IANA timezone mapping
// Source: unicode.org/cldr windowsZones.xml
const WINDOWS_TO_IANA: Record<string, string> = {
    'Dateline Standard Time': 'Etc/GMT+12',
    'UTC-11': 'Etc/GMT+11',
    'Aleutian Standard Time': 'America/Adak',
    'Hawaiian Standard Time': 'Pacific/Honolulu',
    'Marquesas Standard Time': 'Pacific/Marquesas',
    'Alaskan Standard Time': 'America/Anchorage',
    'UTC-09': 'Etc/GMT+9',
    'Pacific Standard Time (Mexico)':
        'America/Tijuana',
    'UTC-08': 'Etc/GMT+8',
    'Pacific Standard Time': 'America/Los_Angeles',
    'US Mountain Standard Time': 'America/Phoenix',
    'Mountain Standard Time (Mexico)':
        'America/Chihuahua',
    'Mountain Standard Time': 'America/Denver',
    'Yukon Standard Time': 'America/Whitehorse',
    'Central America Standard Time':
        'America/Guatemala',
    'Central Standard Time': 'America/Chicago',
    'Easter Island Standard Time':
        'Pacific/Easter',
    'Central Standard Time (Mexico)':
        'America/Mexico_City',
    'Canada Central Standard Time':
        'America/Regina',
    'SA Pacific Standard Time': 'America/Bogota',
    'Eastern Standard Time (Mexico)':
        'America/Cancun',
    'Eastern Standard Time': 'America/New_York',
    'Haiti Standard Time': 'America/Port-au-Prince',
    'Cuba Standard Time': 'America/Havana',
    'US Eastern Standard Time':
        'America/Indianapolis',
    'Turks And Caicos Standard Time':
        'America/Grand_Turk',
    'Paraguay Standard Time': 'America/Asuncion',
    'Atlantic Standard Time': 'America/Halifax',
    'Venezuela Standard Time': 'America/Caracas',
    'Central Brazilian Standard Time':
        'America/Cuiaba',
    'SA Western Standard Time':
        'America/La_Paz',
    'Pacific SA Standard Time': 'America/Santiago',
    'Newfoundland Standard Time':
        'America/St_Johns',
    'Tocantins Standard Time':
        'America/Araguaina',
    'E. South America Standard Time':
        'America/Sao_Paulo',
    'SA Eastern Standard Time': 'America/Cayenne',
    'Argentina Standard Time':
        'America/Buenos_Aires',
    'Greenland Standard Time': 'America/Godthab',
    'Montevideo Standard Time':
        'America/Montevideo',
    'Saint Pierre Standard Time':
        'America/Miquelon',
    'Bahia Standard Time': 'America/Bahia',
    'UTC-02': 'Etc/GMT+2',
    'Azores Standard Time': 'Atlantic/Azores',
    'Cape Verde Standard Time':
        'Atlantic/Cape_Verde',
    UTC: 'Etc/UTC',
    'GMT Standard Time': 'Europe/London',
    'Greenwich Standard Time':
        'Atlantic/Reykjavik',
    'Sao Tome Standard Time': 'Africa/Sao_Tome',
    'Morocco Standard Time': 'Africa/Casablanca',
    'W. Europe Standard Time': 'Europe/Berlin',
    'Central Europe Standard Time':
        'Europe/Budapest',
    'Romance Standard Time': 'Europe/Paris',
    'Central European Standard Time':
        'Europe/Warsaw',
    'W. Central Africa Standard Time':
        'Africa/Lagos',
    'Jordan Standard Time': 'Asia/Amman',
    'GTB Standard Time': 'Europe/Bucharest',
    'Middle East Standard Time': 'Asia/Beirut',
    'Egypt Standard Time': 'Africa/Cairo',
    'E. Europe Standard Time': 'Europe/Chisinau',
    'Syria Standard Time': 'Asia/Damascus',
    'West Bank Standard Time': 'Asia/Hebron',
    'South Africa Standard Time':
        'Africa/Johannesburg',
    'FLE Standard Time': 'Europe/Kiev',
    'Israel Standard Time': 'Asia/Jerusalem',
    'South Sudan Standard Time': 'Africa/Juba',
    'Kaliningrad Standard Time':
        'Europe/Kaliningrad',
    'Sudan Standard Time': 'Africa/Khartoum',
    'Libya Standard Time': 'Africa/Tripoli',
    'Namibia Standard Time': 'Africa/Windhoek',
    'Arabic Standard Time': 'Asia/Baghdad',
    'Turkey Standard Time': 'Europe/Istanbul',
    'Arab Standard Time': 'Asia/Riyadh',
    'Belarus Standard Time': 'Europe/Minsk',
    'Russian Standard Time': 'Europe/Moscow',
    'E. Africa Standard Time': 'Africa/Nairobi',
    'Volgograd Standard Time': 'Europe/Volgograd',
    'Iran Standard Time': 'Asia/Tehran',
    'Arabian Standard Time': 'Asia/Dubai',
    'Astrakhan Standard Time': 'Europe/Astrakhan',
    'Azerbaijan Standard Time': 'Asia/Baku',
    'Russia Time Zone 3': 'Europe/Samara',
    'Mauritius Standard Time':
        'Indian/Mauritius',
    'Saratov Standard Time': 'Europe/Saratov',
    'Georgian Standard Time': 'Asia/Tbilisi',
    'Caucasus Standard Time': 'Asia/Yerevan',
    'Afghanistan Standard Time': 'Asia/Kabul',
    'West Asia Standard Time': 'Asia/Tashkent',
    'Ekaterinburg Standard Time':
        'Asia/Yekaterinburg',
    'Pakistan Standard Time': 'Asia/Karachi',
    'Qyzylorda Standard Time':
        'Asia/Qyzylorda',
    'India Standard Time': 'Asia/Calcutta',
    'Sri Lanka Standard Time': 'Asia/Colombo',
    'Nepal Standard Time': 'Asia/Katmandu',
    'Central Asia Standard Time': 'Asia/Almaty',
    'Bangladesh Standard Time': 'Asia/Dhaka',
    'Omsk Standard Time': 'Asia/Omsk',
    'Myanmar Standard Time': 'Asia/Rangoon',
    'SE Asia Standard Time': 'Asia/Bangkok',
    'Altai Standard Time': 'Asia/Barnaul',
    'W. Mongolia Standard Time':
        'Asia/Hovd',
    'North Asia Standard Time':
        'Asia/Krasnoyarsk',
    'N. Central Asia Standard Time':
        'Asia/Novosibirsk',
    'Tomsk Standard Time': 'Asia/Tomsk',
    'China Standard Time': 'Asia/Shanghai',
    'North Asia East Standard Time':
        'Asia/Irkutsk',
    'Singapore Standard Time': 'Asia/Singapore',
    'W. Australia Standard Time':
        'Australia/Perth',
    'Taipei Standard Time': 'Asia/Taipei',
    'Ulaanbaatar Standard Time':
        'Asia/Ulaanbaatar',
    'Aus Central W. Standard Time':
        'Australia/Eucla',
    'Transbaikal Standard Time': 'Asia/Chita',
    'Tokyo Standard Time': 'Asia/Tokyo',
    'North Korea Standard Time':
        'Asia/Pyongyang',
    'Korea Standard Time': 'Asia/Seoul',
    'Yakutsk Standard Time': 'Asia/Yakutsk',
    'Cen. Australia Standard Time':
        'Australia/Adelaide',
    'AUS Central Standard Time':
        'Australia/Darwin',
    'E. Australia Standard Time':
        'Australia/Brisbane',
    'AUS Eastern Standard Time':
        'Australia/Sydney',
    'West Pacific Standard Time':
        'Pacific/Port_Moresby',
    'Tasmania Standard Time':
        'Australia/Hobart',
    'Vladivostok Standard Time':
        'Asia/Vladivostok',
    'Lord Howe Standard Time':
        'Australia/Lord_Howe',
    'Bougainville Standard Time':
        'Pacific/Bougainville',
    'Russia Time Zone 10':
        'Asia/Srednekolymsk',
    'Magadan Standard Time': 'Asia/Magadan',
    'Norfolk Standard Time':
        'Pacific/Norfolk',
    'Sakhalin Standard Time':
        'Asia/Sakhalin',
    'Central Pacific Standard Time':
        'Pacific/Guadalcanal',
    'Russia Time Zone 11':
        'Asia/Kamchatka',
    'New Zealand Standard Time':
        'Pacific/Auckland',
    'UTC+12': 'Etc/GMT-12',
    'Fiji Standard Time': 'Pacific/Fiji',
    'Chatham Islands Standard Time':
        'Pacific/Chatham',
    'UTC+13': 'Etc/GMT-13',
    'Tonga Standard Time': 'Pacific/Tongatapu',
    'Samoa Standard Time': 'Pacific/Apia',
    'Line Islands Standard Time':
        'Pacific/Kiritimati'
};

export function toIanaTimeZone(id: string): string {
    if (!id || id.includes('/') || id === 'UTC') {
        return id;
    }

    return WINDOWS_TO_IANA[id] ?? 'UTC';
}

export function isBrowserInTenantTz(
    tenantTz: string
): boolean {
    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (browserTz === tenantTz) {
        return true;
    }

    // Compare UTC offsets as fallback for equivalent
    // timezones with different IANA names
    const now = new Date();
    const fmt = (tz: string) =>
        new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            timeZoneName: 'shortOffset'
        }).formatToParts(now)
            .find(p => p.type === 'timeZoneName')?.value;

    return fmt(browserTz) === fmt(tenantTz);
}

/**
 * Returns "YYYY-MM-DD" for today's calendar day in the TENANT's timezone,
 * NOT the browser's. Operation β from the PROD-1465 reconciliation:
 * computing a fresh calendar-day ANCHOR for comparison. The backend
 * concentrates all tenant-TZ math at the single write-site boundary
 * (IsoDateMapper.ToUtcDateTime) — read sites do NOT shift stored
 * values, matching the discipline in scheduled-date.pipe.ts. Mismatching
 * "today" between frontend (browser TZ) and backend (tenant TZ) was
 * the structural cause of the ScheduledPaymentStartDateInPast bug.
 *
 * `tellerSiteTimeZoneId` is documented IANA on the wire, but legacy
 * Windows ids may still appear; toIanaTimeZone handles both.
 */
export function tenantTodayIsoDate(tellerSiteTimeZoneId: string): string {
    const ianaTz = toIanaTimeZone(tellerSiteTimeZoneId);
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: ianaTz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).formatToParts(new Date());
    const year = parts.find(p => p.type === 'year')!.value;
    const month = parts.find(p => p.type === 'month')!.value;
    const day = parts.find(p => p.type === 'day')!.value;

    return `${year}-${month}-${day}`;
}

const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const MONTH_LABELS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

@Pipe({
    name: 'scheduledDate',
    standalone: false
})
export class ScheduledDatePipe implements PipeTransform {
    // Wire format is "YYYY-MM-DD". Render verbatim — no `new Date(value)`,
    // no `Intl.DateTimeFormat({ timeZone: ... })`, no tenant-timezone
    // math. Each of those was the regression we shipped this pipe to
    // fix (PROD-1465). If you're tempted to add timezone handling here
    // because a stakeholder asked to "show the date in the tenant's
    // timezone," stop — these are calendar-day fields, not instants;
    // the wire string already IS the calendar day to display.
    transform(value: string | null | undefined): string {
        if (!value || !ISO_DATE_REGEX.test(value)) {
            return '';
        }

        const [yearStr, monthStr, dayStr] = value.split('-');
        const monthIndex = Number(monthStr) - 1;
        const day = Number(dayStr);

        return `${MONTH_LABELS[monthIndex]} ${day}, ${yearStr}`;
    }
}
